import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { OpenModal, openModalAction } from '../../../../../form-modal/actions';
import { UpdateFormDetails, updateFormDetailsAction } from '../actions/update-form-details';
import { getClaim } from '../../../../../claim';
import { Nullable } from '../../../../../shared-types';
import { ClaimType } from '../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    updateFormDetails?: UpdateFormDetails;
    disableEditButton?: boolean;
    type: string;
    claimType?: Nullable<ClaimType>;
}
interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const addressDetailsView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
    type,
    claimType,
}: Props) => {
    let addressDetails;
    if (formDetails) {
        addressDetails =
            type === 'LifeAssured'
                ? formDetails.lifeAssured?.addressDetails
                : formDetails.policyHolder?.individual?.addressDetails;
    }
    const isThePolicyHolderAnIndividualOrCompany =
        formDetails?.policyHolder?.isThePolicyHolderAnIndividualOrCompany;
    let header = claimType === ClaimType.Disability ? 'Residential Details' : 'Address Details';
    if (isThePolicyHolderAnIndividualOrCompany === 'Company') {
        header = 'Business Address';
    }
    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        {header}
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                <Grid container justify="flex-start">
                    <Grid item xs={12} container justify="flex-start">
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label={
                                    claimType === ClaimType.Disability
                                        ? 'Residential Details'
                                        : 'Residential Address'
                                }
                                value={[
                                    'RSA Street Address',
                                    addressDetails?.addressLineOne,
                                    addressDetails?.addressLineTwo,
                                    addressDetails?.addressSuburb,
                                    addressDetails?.townOrSuburb,
                                    addressDetails?.city,
                                    addressDetails?.postalCode,
                                    addressDetails?.province,
                                ]
                                    .filter(Boolean) // removes null, undefined, empty string
                                    .join('\n')}
                            />
                        </Grid>
                        {claimType !== ClaimType.Disability && (
                            <Grid item xs={6} lg={6}>
                                <LabeledValue
                                    label="Postal Address"
                                    value={
                                        addressDetails?.sameAsResidentialAddress
                                            ? 'Same as residential'
                                            : `${
                                                  !addressDetails ||
                                                  addressDetails?.postalAddressLineOne === null
                                                      ? ''
                                                      : addressDetails?.postalAddressLineOne
                                              } ${'\n'} ${
                                                  !addressDetails ||
                                                  addressDetails?.postalAddressLineTwo === null
                                                      ? ''
                                                      : addressDetails?.postalAddressLineTwo
                                              } ${'\n'} ${
                                                  !addressDetails ||
                                                  addressDetails?.postalAddressSuburb === null
                                                      ? ''
                                                      : addressDetails?.postalAddressSuburb
                                              }  ${'\n'} ${
                                                  !addressDetails ||
                                                  addressDetails?.postalPostalCode === null
                                                      ? ''
                                                      : addressDetails?.postalPostalCode
                                              }  ${'\n'} ${
                                                  !addressDetails ||
                                                  addressDetails?.country === null
                                                      ? ''
                                                      : addressDetails?.country
                                              }`
                                    }
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
    updateFormDetails: updateFormDetailsAction,
};

export const AddressDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(addressDetailsView));
